/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Checkbox,
  Divider,
  Grid,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  Typography,
  Tooltip,
  IconButton,
} from '@material-ui/core';

import SearchIcon from "@material-ui/icons/Search";
import { Skeleton } from "@material-ui/lab";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    justifyContent: "space-evenly",
  },
  cardHeader: {
    fontSize: "0.95rem",
    fontFamily: "Open Sans, sans-serif",
  },
  list: {
    height: 350,
    minHeight: 200,
    maxHeight: 350,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  listItem: {
    display: "flex",
    "& > .MuiListItemText-root > span": {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      wordBreak: "keep-all",
      overflow: "hidden",
    },
  },
}));

const LoadingItem = () => (
  <ListItem style={{ padding: ".5rem" }}>
    <Skeleton />
  </ListItem>
);

const ItemsFilter = ({ label, loading, filteringItems, verifyItems }) => {
  const isMobile = IsMobile();

  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (e) => {
    e.preventDefault();

    setFilterValue(e.target.value);
  };

  const handleVerify = useCallback(() => {
    verifyItems(filterValue);
  }, [filterValue, verifyItems]);

  const onKeyPress = useCallback(
    (e) => {
      if (e.code === "Enter") {
        handleVerify();
      }
    },
    [handleVerify]
  );

  return (
    <Box display="flex" alignItems="center" width={isMobile ? "90%" : "40%"}>
      <TextField
        margin="dense"
        label={`Filtrar ${label}`}
        type="text"
        fullWidth
        variant="outlined"
        disabled={loading || filteringItems}
        value={filterValue}
        style={{ marginBottom: 10 }}
        onChange={handleFilterChange}
        inputProps={{
          onKeyPress,
        }}
      />
      <IconButtonLoader
        title="Filtrar opções"
        onClick={handleVerify}
        extraStyle={{ marginLeft: 10 }}
        icon={<SearchIcon color="primary" style={{ width: 18, height: 18 }} />}
        size="small"
        disabled={loading || filteringItems}
      />
    </Box>
  );
};

const ItemsList = ({
  label,
  initialItems,
  loading,
  childLinked,
  setChildLinked,
  parentLinked,
  setParentLinked,
}) => {
  let countMenusLeft = 0;

  const classes = useStyles();
  const isMobile = IsMobile();

  const [items, setItems] = useState(initialItems || null);
  const [countLeft, setCountLeft] = useState(0);
  const [countRight, setCountRight] = useState(0);
  const [filteringItems, setFilteringItems] = useState(false);

  const [showListOptions, setShowListOptions] = useState(false);
  const [showListSubOptions, setShowListSubOptions] = useState(false);
  const [showListSubOptionsFilter, setShowListSubOptionsFilter] =
    useState(false);
  const [typeSystem, setTypeSystem] = useState("");
  const [typeSubSystem, setTypeSubSystem] = useState("");
  const [listSubSystemFilter, setListSubSystemFilter] = useState([]);

  const verifyItems = useCallback(
    (filterValue) => {
      setFilteringItems(true);
      setShowListOptions(false);
      setShowListSubOptions(false);
      setShowListSubOptionsFilter(false);
      setListSubSystemFilter([]);
      return new Promise((resolve) => {
        const valueToCheck = filterValue.toLowerCase();

        const listParents = [];
        const listChild = [];
        const listSystemChild = [];

        if (valueToCheck === "") {
          setItems(initialItems);
        } else {
          const newList = initialItems.filter((item) => {
            item?.ListMenus?.filter((disponiveis) => {
              if (
                disponiveis?.Descricao?.toLowerCase().includes(valueToCheck)
              ) {
                listParents.push(disponiveis);
                if (listSystemChild.indexOf(item?.Sistema) === -1) {
                  listSystemChild.push(item?.Sistema);
                }
                if (listSystemChild.indexOf(disponiveis?.Descricao) === -1) {
                  listSystemChild.push(disponiveis?.Descricao);
                }
              }
            });

            item?.ListMenus?.map((disponiveis) => {
              return disponiveis?.ListMenusFilhos?.filter((filhos) => {
                if (filhos?.Descricao?.toLowerCase().includes(valueToCheck)) {
                  listChild.push(filhos);
                  if (listSystemChild.indexOf(disponiveis?.Descricao) === -1) {
                    listSystemChild.push(disponiveis?.Descricao);
                  }
                }
              });
            });

            if (listParents?.length !== 0 || listChild?.length !== 0) {
              setShowListSubOptionsFilter(true);
              setListSubSystemFilter(listSystemChild);
              return item;
            }
          });
          setItems(newList);
        }

        resolve(setFilteringItems(false));
      });
    },
    [initialItems]
  );

  const countingMenusDisponiveis = (menuLeft) => {
    countMenusLeft = menuLeft?.length + countMenusLeft;
    setCountLeft(countMenusLeft);
  };

  const countingMenusVinculados = (child, parent) => {
    setCountRight(child?.length + parent?.length);
  };

  useEffect(() => {
    if (initialItems?.length !== 0) {
      setItems(initialItems);
      countingMenusDisponiveis(initialItems);
      countingMenusVinculados(childLinked, parentLinked);

      initialItems?.map((item) => {
        countingMenusDisponiveis(item?.ListMenus);
        item?.ListMenus?.map((filhos) => {
          if (filhos?.ListMenusFilhos?.length !== 0) {
            countingMenusDisponiveis(filhos?.ListMenusFilhos);
          }
        });
      });
    }
  }, [initialItems, childLinked, parentLinked]);

  function arrayCompare(first, last) {
    const result = first.filter(function (item) {
      return last.indexOf(item) > -1;
    });
    return result.length;
  }

  const handleToggleChild = useCallback(
    (child, parent, listChild, system, parentList) => {
      let newCheckedParent = [...parentLinked];
      let newCheckedChild = [...childLinked];

      const verifyChild = listChild?.map((item) => {
        return item?.IdMenu;
      });

      const verifyParent = parentList?.map((item) => {
        return item?.IdMenu;
      });

      if (childLinked?.indexOf(child) === -1) {
        newCheckedChild?.push(child);
        if (parentLinked?.indexOf(parent) === -1) {
          newCheckedParent?.push(parent);
        }
        const currentIndexSystem = newCheckedParent?.indexOf(system);
        if (currentIndexSystem === -1) {
          newCheckedParent.push(system);
        }
      } else {
        newCheckedChild = newCheckedChild?.filter(function (element, i) {
          if (element !== child) {
            return newCheckedChild?.indexOf(element) === i;
          }
        });

        if (arrayCompare(newCheckedChild, verifyChild) === 0) {
          newCheckedParent = newCheckedParent?.filter(function (element, i) {
            if (element !== parent) {
              return newCheckedParent?.indexOf(element) === i;
            }
          });
        }

        const isInArray = verifyParent.some((el) =>
          newCheckedParent.includes(el)
        );
        if (!isInArray) {
          const currentIndexSystem = newCheckedParent?.indexOf(system);
          if (currentIndexSystem !== -1) {
            newCheckedParent.splice(currentIndexSystem, 1);
          }
        }
      }

      setParentLinked(newCheckedParent);
      setChildLinked(newCheckedChild);
    },
    [childLinked, setChildLinked, parentLinked, setParentLinked]
  );

  const handleToggleParent = useCallback(
    (parentId, child, system, parentList) => {
      const currentIndexParent = parentLinked?.indexOf(parentId);
      const newCheckedParent = [...parentLinked];
      let newCheckedChild = [...childLinked];

      const verifyChild = child?.map((item) => {
        return item?.IdMenu;
      });

      const verifyParent = parentList?.map((item) => {
        return item?.IdMenu;
      });

      if (currentIndexParent === -1) {
        newCheckedParent.push(parentId);

        const currentIndexSystem = newCheckedParent?.indexOf(system);
        if (currentIndexSystem === -1) {
          newCheckedParent.push(system);
        }

        verifyChild?.map((item) => {
          return newCheckedChild.push(item);
        });
      } else {
        newCheckedChild = newCheckedChild.filter(function (child) {
          return verifyChild.indexOf(child) === -1;
        });
        newCheckedParent.splice(currentIndexParent, 1);

        const isInArray = verifyParent.some((el) =>
          newCheckedParent.includes(el)
        );
        if (!isInArray) {
          const currentIndexSystem = newCheckedParent?.indexOf(system);
          if (currentIndexSystem !== -1) {
            newCheckedParent.splice(currentIndexSystem, 1);
          }
        }
      }
      setParentLinked(newCheckedParent);
      setChildLinked(newCheckedChild);
    },
    [childLinked, setChildLinked, parentLinked, setParentLinked]
  );

  const handleToggleAllList = useCallback(
    (system, options) => {
      const newCheckedParent = [...parentLinked];
      const newCheckedChild = [...childLinked];

      if (newCheckedParent?.indexOf(system) !== -1) {
        options?.ListMenus?.map((parent) => {
          const currentIndexParent = newCheckedParent?.indexOf(parent?.IdMenu);
          if (currentIndexParent !== -1) {
            newCheckedParent.splice(currentIndexParent, 1);
          }

          const currentIndexSystem = newCheckedParent?.indexOf(system);
          if (currentIndexSystem !== -1) {
            newCheckedParent.splice(currentIndexSystem, 1);
          }

          parent?.ListMenusFilhos?.map((child) => {
            const currentIndexChild = newCheckedChild?.indexOf(child?.IdMenu);
            if (currentIndexChild !== -1) {
              newCheckedChild.splice(currentIndexChild, 1);
            }
          });
        });
        setParentLinked(newCheckedParent);
        setChildLinked(newCheckedChild);
      } else {
        options?.ListMenus?.map((parent) => {
          const currentIndexParent = newCheckedParent?.indexOf(parent?.IdMenu);
          if (currentIndexParent === -1) {
            newCheckedParent.push(parent?.IdMenu);
          }

          const currentIndexSystem = newCheckedParent?.indexOf(system);
          if (currentIndexSystem === -1) {
            newCheckedParent.push(system);
          }
          parent?.ListMenusFilhos?.map((child) => {
            const currentIndexChild = newCheckedChild?.indexOf(child?.IdMenu);
            if (currentIndexChild === -1) {
              newCheckedChild.push(child?.IdMenu);
            }
          });
        });
        setParentLinked(newCheckedParent);
        setChildLinked(newCheckedChild);
      }
    },
    [childLinked, setChildLinked, parentLinked, setParentLinked]
  );

  useEffect(() => {
    const currentIndex = parentLinked?.indexOf(typeSystem);
    if (currentIndex === -1 && typeSystem) {
      setShowListOptions(true);
    }
  }, [typeSystem, parentLinked]);

  useEffect(() => {
    const currentIndex = childLinked?.indexOf(typeSubSystem);
    if (currentIndex === -1 && typeSubSystem) {
      setShowListSubOptions(true);
    }
  }, [typeSubSystem, childLinked]);

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={
            isMobile
              ? {
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }
              : {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "0.1rem solid #D0D0D0",
                }
          }
        >
          {!loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                className={classes.cardHeader}
                style={{ color: "#994E53", marginRight: "1rem" }}
              >
                {label}
              </Typography>
              <Typography
                className={classes.cardHeader}
                style={{ color: "rgba(0, 0, 0, 0.54)" }}
              >
                {`${countRight}/${countLeft} selecionados`}
              </Typography>
            </div>
          )}
          {!loading && (
            <ItemsFilter
              label={label}
              filteringItems={filteringItems}
              loading={loading}
              verifyItems={verifyItems}
            />
          )}
        </Grid>
        {!loading && <Divider />}
        {items?.length !== 0 && (
          <div
            className={classes.list}
            style={{ overflowX: "hidden", width: "100%" }}
          >
            {!loading && items ? (
              items?.map((menuOptions) => {
                return (
                  <>
                    <ListItem
                      style={{
                        marginTop: "-0.75rem",
                        marginBottom: "-2.25rem",
                      }}
                      key={menuOptions?.Sistema}
                      role="listitem"
                      draggable
                      className={classes.listItem}
                    >
                      <IconButton
                        size="small"
                        onClick={() => {
                          setShowListOptions(!showListOptions);
                          setTypeSystem(menuOptions?.Sistema);
                        }}
                      >
                        {(showListOptions &&
                          menuOptions?.Sistema === typeSystem) ||
                        showListSubOptionsFilter ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                      </IconButton>
                      <ListItemIcon style={{ marginRight: "-0.5rem" }}>
                        <Checkbox
                          checked={
                            parentLinked?.indexOf(menuOptions?.Sistema) !== -1
                          }
                          tabIndex={-1}
                          color="primary"
                          onClick={() =>
                            handleToggleAllList(
                              menuOptions?.Sistema,
                              menuOptions
                            )
                          }
                        />
                      </ListItemIcon>
                      <Tooltip title={menuOptions?.Sistema}>
                        <ListItemText
                          id={menuOptions?.Sistema}
                          primary={menuOptions?.Sistema}
                        />
                      </Tooltip>
                    </ListItem>
                    {menuOptions?.ListMenus?.map((options) => {
                      if (
                        (showListOptions &&
                          menuOptions?.Sistema === typeSystem) ||
                        (showListSubOptionsFilter &&
                          listSubSystemFilter?.includes(options?.Descricao))
                      ) {
                        return (
                          <>
                            <ListItem
                              style={{
                                marginLeft: "1.5rem",
                                marginTop: "-2.25rem",
                                marginBottom: "-2.25rem",
                              }}
                              key={options?.IdMenu}
                              role="listitem"
                              draggable
                              className={classes.listItem}
                            >
                              {options?.ListMenusFilhos?.length !== 0 ? (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setShowListSubOptions(!showListSubOptions);
                                    setTypeSubSystem(options?.Descricao);
                                  }}
                                >
                                  {(showListSubOptions &&
                                    typeSubSystem === options?.Descricao) ||
                                  (showListSubOptionsFilter &&
                                    listSubSystemFilter?.includes(
                                      options?.Descricao
                                    )) ? (
                                    <ExpandLess />
                                  ) : (
                                    <ExpandMore />
                                  )}
                                </IconButton>
                              ) : (
                                <div
                                  role="presentation"
                                  style={{ marginLeft: "1.85rem" }}
                                ></div>
                              )}
                              <ListItemIcon style={{ marginRight: "-0.5rem" }}>
                                <Checkbox
                                  checked={
                                    parentLinked?.indexOf(options?.IdMenu) !==
                                    -1
                                  }
                                  tabIndex={-1}
                                  inputProps={{
                                    "aria-labelledby": options?.IdMenu,
                                  }}
                                  color="primary"
                                  onClick={() =>
                                    handleToggleParent(
                                      options?.IdMenu,
                                      options?.ListMenusFilhos,
                                      menuOptions?.Sistema,
                                      menuOptions?.ListMenus
                                    )
                                  }
                                />
                              </ListItemIcon>
                              <Tooltip title={options?.Descricao}>
                                <ListItemText
                                  id={options?.IdMenu}
                                  primary={options?.Descricao}
                                />
                              </Tooltip>
                            </ListItem>
                            {((showListSubOptions &&
                              options?.Descricao === typeSubSystem) ||
                              (showListSubOptionsFilter &&
                                listSubSystemFilter?.includes(
                                  options?.Descricao
                                ))) &&
                              options?.ListMenusFilhos?.map((filhos) => {
                                return (
                                  <ListItem
                                    style={{
                                      marginLeft: "5rem",
                                      marginBottom: "-2rem",
                                      marginTop: "-2.5rem",
                                    }}
                                    key={filhos?.IdMenu}
                                    role="listitem"
                                    draggable
                                    className={classes.listItem}
                                  >
                                    <ListItemIcon
                                      style={{ marginRight: "-0.5rem" }}
                                    >
                                      <Checkbox
                                        checked={
                                          childLinked?.indexOf(
                                            filhos?.IdMenu
                                          ) !== -1
                                        }
                                        tabIndex={-1}
                                        inputProps={{
                                          "aria-labelledby": filhos?.IdMenu,
                                        }}
                                        color="primary"
                                        onClick={() =>
                                          handleToggleChild(
                                            filhos?.IdMenu,
                                            options?.IdMenu,
                                            options?.ListMenusFilhos,
                                            menuOptions?.Sistema,
                                            menuOptions?.ListMenus
                                          )
                                        }
                                      />
                                    </ListItemIcon>
                                    <Tooltip title={filhos?.Descricao}>
                                      <ListItemText
                                        id={filhos?.IdMenu}
                                        primary={filhos?.Descricao}
                                      />
                                    </Tooltip>
                                  </ListItem>
                                );
                              })}
                          </>
                        );
                      }
                    })}
                  </>
                );
              })
            ) : (
              <>
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
                <LoadingItem />
              </>
            )}
          </div>
        )}
      </Grid>
    </>
  );
};

export default function TransferList({
  loading,
  initial,
  label,
  setVinculados,
}) {
  const isMobile = IsMobile();

  const classes = useStyles();
  const [items, setItems] = useState(initial || null);
  const [childLinked, setChildLinked] = useState([]);
  const [parentLinked, setParentLinked] = useState([]);

  useEffect(() => {
    setItems(initial);
  }, [initial]);

  useEffect(() => {
    const listVinculados = parentLinked.concat(childLinked);
    initial?.map((options) => {
      const currentIndexSystem = listVinculados?.indexOf(options?.Sistema);
      if (currentIndexSystem !== -1) {
        listVinculados.splice(currentIndexSystem, 1);
      }
    });
    setVinculados(listVinculados);
  }, [parentLinked, childLinked]);

  useEffect(() => {
    const parentLinkedList = [];
    const childLinkedList = [];
    initial?.map((options) => {
      options?.ListMenus?.map((parent) => {
        if (parent?.Vinculado === true) {
          if (parentLinkedList.indexOf(options?.Sistema) === -1) {
            parentLinkedList.push(options?.Sistema);
          }
          parentLinkedList.push(parent?.IdMenu);
        }

        if (parent?.ListMenusFilhos?.length !== 0) {
          parent?.ListMenusFilhos?.map((child) => {
            if (child?.Vinculado === true) {
              childLinkedList.push(child?.IdMenu);
            }
          });
        }
      });
    });

    setParentLinked(parentLinkedList);
    setChildLinked(childLinkedList);
  }, [initial]);

  return (
    <Grid container alignItems="flex-start" className={classes.root}>
      <Grid
        item
        xs={12}
        style={isMobile ? { padding: "0 0.5rem" } : { padding: "0 2rem" }}
      >
        <ItemsList
          label={label}
          initialItems={items}
          loading={loading}
          childLinked={childLinked}
          setChildLinked={setChildLinked}
          parentLinked={parentLinked}
          setParentLinked={setParentLinked}
        />
      </Grid>
    </Grid>
  );
}
